import React from "react";
import {Helmet} from "react-helmet";
import Section404 from "../../components/Section404/Section404";
import BgGlassmorphism from "../../components/BgGlassmorphism/BgGlassmorphism";


const Page404: React.FC = () => (
    <div className="nc-Page404">
        <Helmet>
            <title>404 | CryptoVerse</title>
        </Helmet>
        <BgGlassmorphism/>
        <div className="container pb-16 lg:pb-28">
            <Section404/>
        </div>
    </div>
);

export default Page404;